function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { fillWildcards } from './utils/fill-wildcards.mjs';
import { removeNonTranslationalTransform } from './utils/unit-conversion.mjs';
import { frame } from '../../frameloop/frame.mjs';
var toResolve = new Set();
var isScheduled = false;
var anyNeedsMeasurement = false;
var isForced = false;

function measureAllKeyframes() {
  if (anyNeedsMeasurement) {
    var resolversToMeasure = Array.from(toResolve).filter(function (resolver) {
      return resolver.needsMeasurement;
    });
    var elementsToMeasure = new Set(resolversToMeasure.map(function (resolver) {
      return resolver.element;
    }));
    var transformsToRestore = new Map();
    /**
     * Write pass
     * If we're measuring elements we want to remove bounding box-changing transforms.
     */

    elementsToMeasure.forEach(function (element) {
      var removedTransforms = removeNonTranslationalTransform(element);
      if (!removedTransforms.length) return;
      transformsToRestore.set(element, removedTransforms);
      element.render();
    }); // Read

    resolversToMeasure.forEach(function (resolver) {
      return resolver.measureInitialState();
    }); // Write

    elementsToMeasure.forEach(function (element) {
      element.render();
      var restore = transformsToRestore.get(element);

      if (restore) {
        restore.forEach(function (_ref) {
          var _element$getValue;

          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          (_element$getValue = element.getValue(key)) === null || _element$getValue === void 0 ? void 0 : _element$getValue.set(value);
        });
      }
    }); // Read

    resolversToMeasure.forEach(function (resolver) {
      return resolver.measureEndState();
    }); // Write

    resolversToMeasure.forEach(function (resolver) {
      if (resolver.suspendedScrollY !== undefined) {
        window.scrollTo(0, resolver.suspendedScrollY);
      }
    });
  }

  anyNeedsMeasurement = false;
  isScheduled = false;
  toResolve.forEach(function (resolver) {
    return resolver.complete(isForced);
  });
  toResolve.clear();
}

function readAllKeyframes() {
  toResolve.forEach(function (resolver) {
    resolver.readKeyframes();

    if (resolver.needsMeasurement) {
      anyNeedsMeasurement = true;
    }
  });
}

function flushKeyframeResolvers() {
  isForced = true;
  readAllKeyframes();
  measureAllKeyframes();
  isForced = false;
}

var KeyframeResolver = /*#__PURE__*/function () {
  function KeyframeResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
    var isAsync = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    _classCallCheck(this, KeyframeResolver);

    this.state = "pending";
    /**
     * Track whether this resolver is async. If it is, it'll be added to the
     * resolver queue and flushed in the next frame. Resolvers that aren't going
     * to trigger read/write thrashing don't need to be async.
     */

    this.isAsync = false;
    /**
     * Track whether this resolver needs to perform a measurement
     * to resolve its keyframes.
     */

    this.needsMeasurement = false;
    this.unresolvedKeyframes = _toConsumableArray(unresolvedKeyframes);
    this.onComplete = onComplete;
    this.name = name;
    this.motionValue = motionValue;
    this.element = element;
    this.isAsync = isAsync;
  }

  _createClass(KeyframeResolver, [{
    key: "scheduleResolve",
    value: function scheduleResolve() {
      this.state = "scheduled";

      if (this.isAsync) {
        toResolve.add(this);

        if (!isScheduled) {
          isScheduled = true;
          frame.read(readAllKeyframes);
          frame.resolveKeyframes(measureAllKeyframes);
        }
      } else {
        this.readKeyframes();
        this.complete();
      }
    }
  }, {
    key: "readKeyframes",
    value: function readKeyframes() {
      var unresolvedKeyframes = this.unresolvedKeyframes,
          name = this.name,
          element = this.element,
          motionValue = this.motionValue; // If initial keyframe is null we need to read it from the DOM

      if (unresolvedKeyframes[0] === null) {
        var currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get(); // TODO: This doesn't work if the final keyframe is a wildcard

        var finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];

        if (currentValue !== undefined) {
          unresolvedKeyframes[0] = currentValue;
        } else if (element && name) {
          var valueAsRead = element.readValue(name, finalKeyframe);

          if (valueAsRead !== undefined && valueAsRead !== null) {
            unresolvedKeyframes[0] = valueAsRead;
          }
        }

        if (unresolvedKeyframes[0] === undefined) {
          unresolvedKeyframes[0] = finalKeyframe;
        }

        if (motionValue && currentValue === undefined) {
          motionValue.set(unresolvedKeyframes[0]);
        }
      }

      fillWildcards(unresolvedKeyframes);
    }
  }, {
    key: "setFinalKeyframe",
    value: function setFinalKeyframe() {}
  }, {
    key: "measureInitialState",
    value: function measureInitialState() {}
  }, {
    key: "renderEndStyles",
    value: function renderEndStyles() {}
  }, {
    key: "measureEndState",
    value: function measureEndState() {}
  }, {
    key: "complete",
    value: function complete() {
      var isForcedComplete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.state = "complete";
      this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
      toResolve.delete(this);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.state === "scheduled") {
        toResolve.delete(this);
        this.state = "pending";
      }
    }
  }, {
    key: "resume",
    value: function resume() {
      if (this.state === "pending") this.scheduleResolve();
    }
  }]);

  return KeyframeResolver;
}();

export { KeyframeResolver, flushKeyframeResolvers };